








import Vue from 'vue';
import Component from 'vue-class-component';

/**
 *  Reflecting the provided count.
 */
@Component
export default class Counter extends Vue {}
